import { render, staticRenderFns } from "./TogglerLang.vue?vue&type=template&id=d1e446d6&scoped=true&lang=pug&"
import script from "./TogglerLang.vue?vue&type=script&lang=js&"
export * from "./TogglerLang.vue?vue&type=script&lang=js&"
import style0 from "./TogglerLang.vue?vue&type=style&index=0&id=d1e446d6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1e446d6",
  null
  
)

export default component.exports